/**
 * @param {number} days - Number of days to add.
 * @returns {Date} - Date object.
 * */
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
Object.size = function (obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

const knocking = {
  variantState: {
    regular: "regular",
    soldout: "soldout",
    extendedOffer: "extendedoffer",
    holidayShipping: "holidayshipping",
  },
  knockingLogActive: false,
  /**
   *
   * @param  {...any} args
   * @returns
   */
  log: function (...args) {
    if (!this.knockingLogActive) {
      return;
    }
  },
  /**
   * Validates if a URL is a valid AWS Lambda function URL
   * @param {string} url - URL to validate
   * @returns {boolean} - true if valid Lambda URL, false otherwise
   */
  isValidLambdaUrl: function (url) {
    if (!url || typeof url !== "string" || url.trim() === "") {
      return false;
    }

    // AWS Lambda function URL pattern:
    // https://{url-id}.lambda-url.{region}.on.aws[/]
    // url-id: 32 lowercase alphanumeric characters
    // region: AWS region format (e.g., us-east-1, eu-west-1)
    const lambdaUrlPattern = /^https:\/\/[a-z0-9]{32}\.lambda-url\.[a-z0-9-]+\.on\.aws\/?$/;

    return lambdaUrlPattern.test(url.trim());
  },
  /**
   * @param {string} vendor
   * @param {string} sku
   * @param {number} qty
   * @returns {Promise<string[] | null>}
   * */
  getVoucherCode: async function (vendor, sku, qty) {
    if (!vendor || !sku || !qty) {
      console.error(
        "Missing one or more parameters for fetching voucher codes...aborting"
      );
    }

    try {
      let url;

      // Priority: Use Metafield URL if configured AND valid, otherwise fallback to hardcoded URLs
      if (window.voucherLambdaUrl && this.isValidLambdaUrl(window.voucherLambdaUrl)) {
        url = window.voucherLambdaUrl;
      } else {
        if (window.voucherLambdaUrl && !this.isValidLambdaUrl(window.voucherLambdaUrl)) {
          console.warn('[Voucher] Invalid Lambda URL format in metafield voucher_lambda_url:', window.voucherLambdaUrl);
        } else {
          console.warn('[Voucher] Metafield voucher_lambda_url not configured, using fallback URL');
        }

        if (window.storeName === "Knocking Develop") {
          url = "https://tpuorwloi446mxs7pwl2svkiim0nsrwf.lambda-url.us-east-1.on.aws/";
        } else {
          url = "https://2m4fkxdjkw5awnhlb5xgwkjgxe0ltyrt.lambda-url.us-east-1.on.aws";
        }
      }

      const res = await fetch(`${url}?vendor=${vendor}&sku=${sku}&qty=${qty}`);
      if (!res.ok) {
        console.log("res not ok", res);
        throw new Error(res.statusText);
      }

      const data = await res.json();
      if (!data === undefined) {
        throw new Error("Undefined response from server");
      }
      if (data.length && data.length === 0) {
        throw new Error("Empty response from server");
      }
      return data;
    } catch (err) {
      console.log("Error in getVoucherCode: ", err);
      knocking.handleVoucherError(err);
      return null;
    }
  },
  /**
   * @param {unknown} error;
   * */
  handleVoucherError(error) {
    // TODO: alert on slack & notify customer in UI
    console.error("Error in the voucher-code system: ", error);

    /**
     * @type {HTMLElement | null}
     * */
    const alertElement = document.querySelector(".add_to_cart_alert_failed");
    if (alertElement) {
      alertElement.style.display = "block";
    } else {
      window.alert(
        "Oops, something went wrong, please try adding the product to your cart again!"
      );
    }
  },
  /**
   * @param {number} days - Number of days to add.
   * @returns {Date} - Date object.
   * */
  addDays: function (days) {
    const daysToAddInMs = days * 86400000;
    const datePlusDays = new Date(new Date().getTime() + daysToAddInMs);
    return datePlusDays;
  },
  /**
   * @param {number} days - Number of days to add.
   * @returns {Date} - Date object.
   * */
  addBusinessDays: function (days) {
    let date = new Date();
    for (let addedDays = 0; addedDays < days;) {
      date.setDate(date.getDate() + 1);
      let dayOfWeek = date.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }
    return date;
  },
  openCart: function () {
    messenger.emmit(messenger.topics.OPEN_CART);
  },
  /**
   * @param {Cart | null} cart - Cart object.;
   * @returns {void}
   * */
  buildCart: function (cart) {
    if (!cart) {
      console.trace("no cart passed to build cart");
      messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, 0);
      return;
    }
    messenger.emmit(messenger.topics.BUILD_CART, cart);
    messenger.emmit(messenger.topics.CHECK_LIMITS, cart);
    messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, cart.item_count);
  },
  /**
   * @param {number} itemCount - Number of items in the cart.
   * @returns {void}
   * */
  updateCartBubble(itemCount) {
    if (isNaN(itemCount)) {
      console.log("no item count passed to update cart bubble");
      return;
    }
    messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, itemCount);
  },
  /**
   * @param {Cart} cart - Cart object.
   * @returns {void}
   * */
  checkLimits(cart) {
    if (!cart) {
      console.error("no cart passed to check limits");
      return;
    }
    messenger.emmit(messenger.topics.CHECK_LIMITS, cart);
  },
  /**
   *
   * @param {Object} limitObj
   * @returns
   */
  objectToArrayOfObjects: function (limitObj) {
    let arr = [];
    for (const [key, value] of Object.entries(limitObj)) {
      /**
       * @type {Object.<string, any>}
       */
      let tempObj = {};
      tempObj[key] = value;
      arr.push(tempObj);
    }
    return arr;
  },
  async getCart() {
    const cart = await fetch("/cart.js");
    return cart.json();
  },
  async clearCart() {
    // TO DO: also delete from session storage
    try {
      const res = await fetch(`${routes.cart_clear_url}`, {
        ...store.fetchConfig(),
      });
      this.buildCart(null);
      return res.json();
    } catch (error) {
      console.log(error);
    }
  },
  /**
   * @param {Cart | null} cart - Cart object.
   * @param {number | null} diffQuantity - Difference in quantity.
   * @param {string} productId - Product ID.
   * @param {string} rawVendor - Vendor name.
   * @returns {Promise<Limit | null>} - Limit object.
   */
  async returnLimitStatus(cart, diffQuantity, productId, rawVendor = "") {
    const vendor = rawVendor.toString().trim();
    // TO DO: we probably don't need diffQuantity here
    if (cart === null) {
      cart = await store.getCart();
    }
    if (!cart) {
      console.error("cannot get cart in returnLimitStatus");
      return null;
    }
    productId = productId.toString();
    let item = cart.items.find(
      (item) => item.product_id.toString() === productId
    );
    if (item && item.limit) {
      return item.limit;
    } else {
      let limit = this.getProductLimit(productId);
      if (limit) {
        const productLimit = {
          limitReached: false,
          remainingQty: limit,
          type: "product",
          quantity: limit,
        };
        return productLimit;
      }
    }
    // Check brand limit
    item = cart.items.find(
      (item) =>
        item.vendor === vendor && item.limit && item.limit.type === "brand"
    );
    if (item && item.limit) {
      return item.limit;
    } else {
      let limit = this.getBrandLimit(vendor);
      if (limit) {
        const brandLimit = {
          limitReached: false,
          remainingQty: limit,
          type: "brand",
          quantity: limit,
        };
        return brandLimit;
      }
    }

    if (window.enableGlobalProductLimit) {
      const limit = window.globalProductLimit;
      const globalLimit = {
        limitReached: false,
        remainingQty: limit,
        type: "product",
        quantity: limit,
      };
      return globalLimit;
    }
    return null;
  },

  /**
   * @param {string} vendor - Vendor name.
   * @returns {number | null} - Brand limit.
   * */
  getBrandLimit(vendor) {
    const decodedVendor = decodeURIComponent(vendor);
    if (window.brandLimits[decodedVendor]) {
      return window.brandLimits[decodedVendor];
    }
    return null;
  },
  /** @param {string} id - Product ID. */
  getProductLimit(id) {
    if (window.productLimits[id]) {
      return window.productLimits[id];
    }
    return null;
  },
  // calcRemainingQty(limitType, diffQuantity, id, cart = null) {
  //   if (cart === null) {
  //     cart = this.getCart();
  //   }
  //   if (limitType === 'product') {
  //     const item = cart.items.find((item) => item.product_id === id);
  //     return item.limit.remainingQty;
  //   } else if (limitType === 'brand') {
  //     const item = cart.items.find((item) => item.vendor === id);
  //     return item.limit.remainingQty;
  //   }
  // },
  /**
   * @param {string} vendor - Vendor name.
   * @param {number} limit - Limit quantity.
   * @param {number} qty - Quantity.
   * @returns {Promise<{hasLimit: boolean, alreadyInCart: number}>} - Object.
   * */
  async checkIfBrandLimitIsReached(vendor, limit, qty) {
    const decodedVendor = decodeURIComponent(vendor);
    const newQty = parseInt(qty);
    const cart = await this.getCart();
    let itemsOfVendorInCart = 0;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      const lineIndex = i + 1;
      if (
        item.vendor === decodedVendor &&
        !window.productLimits[item.product_id]
      ) {
        itemsOfVendorInCart += item.quantity;
      }
    }
    if (itemsOfVendorInCart + newQty > limit) {
      return { hasLimit: true, alreadyInCart: itemsOfVendorInCart };
    }
    return { hasLimit: false, alreadyInCart: itemsOfVendorInCart };
  },
  /**
   * @param {string} id - Product ID.
   * @param {number} limit - Limit quantity.
   * @param {number} qty - Quantity.
   * @returns {Promise<{hasLimit: boolean, alreadyInCart: number}>} - Object.
   * */
  async checkIfProductLimitIsReached(id, limit, qty) {
    const newQty = parseInt(qty);
    const cart = await this.getCart();
    let itemsOfProductInCart = 0;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      if (item.product_id === parseInt(id)) {
        itemsOfProductInCart += item.quantity;
      }
    }
    if (itemsOfProductInCart + newQty > limit) {
      return { hasLimit: true, alreadyInCart: itemsOfProductInCart };
    }
    return { hasLimit: false, alreadyInCart: itemsOfProductInCart };
  },
  alertProductLimitReached(productName, limit) { },
  /**
   * @param {string} price
   */
  formatToDollarCurrencyString(price) {
    if (!price) {
      return "$";
    }
    let slicedString = price.toString().slice(-2);
    let dollars = price.toString().slice(0, -2);
    let cents = price.toString().slice(-2);
    return `$${dollars}.${cents}`;
  },
  /**
   * @typedef {Object} ShipsByStrings
   * @property {string} shortDate - MM-DD
   * @property {string} longDate - MM-DD-YYYY
   */
  /**
   * @param {string} shippingTagTrimmed - Shipping tag.
   * @returns {ShipsByStrings}
   * */
  calculateShippingDate(shippingTagTrimmed) {
    switch (true) {
      case shippingTagTrimmed && shippingTagTrimmed.includes("businessdays"): {
        const shippingInBusinessDays = shippingTagTrimmed.replace(
          "businessdays",
          ""
        );

        const date = knocking.addBusinessDays(parseInt(shippingInBusinessDays));
        const longDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        const shortDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
        });

        return {
          shortDate,
          longDate,
        };
      }
      case shippingTagTrimmed.includes("days"): {
        const shippingInDays = shippingTagTrimmed.replace("days", "");
        const date = knocking.addDays(parseInt(shippingInDays));
        const longDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        const shortDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
        });

        return {
          shortDate,
          longDate,
        };
      }
      default: {
        const dateArray = shippingTagTrimmed.split("-");
        const year = parseInt(dateArray[0]);
        const month = parseInt(dateArray[1]) - 1; // month is zero based!
        const dayDate = parseInt(dateArray[2]);
        const date = new Date(year, month, dayDate);

        const longDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        const shortDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
        });

        return {
          shortDate,
          longDate,
        };
      }
    }
  },
  /**
   *
   * @param {string[]} tags
   * @returns {string}
   */
  getTagShippingDate(tags) {
    if (!tags) {
      return defaultShippingDate;
    }

    const shippingTag = tags.find((tag) => tag.includes("ships_by-"));
    if (!shippingTag) {
      return defaultShippingDate;
    }

    const trimmedTag = shippingTag.replace("ships_by-", "");
    const kindOfDay = trimmedTag.includes("businessdays")
      ? "businessdays"
      : "days";

    switch (trimmedTag.includes(":")) {
      case true: {
        const shippingRange = trimmedTag.split(":");
        const shippingDateRange = `${shippingRange[0]
          .replace("businessdays", "")
          .replace("days", "")} - ${shippingRange[1]
            .replace("businessdays", "")
            .replace("days", "")} ${kindOfDay}`;
        return shippingDateRange;
      }
      case false: {
        return `${trimmedTag}`;
      }
      default: {
        return defaultShippingDate;
      }
    }
  },
  /**
   * @param {string} shipsByString
   * @returns {string}
   */
  calculateAbsoluteShippingDate(shipsByString) {
    if (!shipsByString) {
      console.error(
        "No input string provided in calculateAbsoluteShippingDate, using default"
      );
      shipsByString = defaultShippingDate;
    }
    let typeOfDay;
    if (
      shipsByString.includes("businessdays") ||
      shipsByString.includes("days")
    ) {
      typeOfDay = shipsByString.includes("businessdays")
        ? "businessdays"
        : "days";
    } else {
      console.error(
        "shipsByString is not a relative date, trying to format absolute date"
      );
      const absoluteDate = new Date(shipsByString);

      return absoluteDate.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
      });
    }
    const trimmedString = shipsByString.replace(typeOfDay, "");
    let datesToConvert = trimmedString.split(" - ");

    if (datesToConvert.length === 0) {
      console.error("No dates to convert in calculateAbsoluteShippingDate");
      return shipsByString;
    }

    let absoluteDate = "";
    for (let i = 0; i < datesToConvert.length; i++) {
      let date = new Date();
      if (typeOfDay === "businessdays") {
        date = this.addBusinessDays(parseInt(datesToConvert[i]));
      } else {
        date = this.addDays(parseInt(datesToConvert[i]));
      }
      absoluteDate += date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
      });
      if (i < datesToConvert.length - 1) {
        absoluteDate += " - ";
      }
    }
    return absoluteDate;
  },
  getUniqueId() {
    return Math.floor(Math.random() * Date.now());
  },
  /**
   * @param {string} key - Cookie key.
   * @param {string} value - Cookie value.
   * @param {number} expDays - Expiration days.
   * @returns {void}
   * */
  setCookie(key, value, expDays) {
    const d = new Date();
    d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = key + "=" + value + ";" + expires + ";path=/";
  },
  /**
   * @param {string} key - Cookie key.
   * @returns {string} - Cookie value.
   */
  getCookie(key) {
    const name = key + "=";
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim(); // Trim leading/trailing spaces
      if (c.indexOf(name) === 0) {
        const value = c.substring(name.length);
        try {
          return decodeURIComponent(value);
        } catch (e) {
          console.warn(`Failed to decode cookie value for key "${key}":`, e);
          return value; // Return raw value as fallback
        }
      }
    }
    return " ";
  },
  showBlur() {
    /** @type {HTMLElement | null} */
    const blurOverlay = document.querySelector("#blur-overlay");
    if (!blurOverlay) return;
    blurOverlay.style.display = "block";
    // Decorative overlay: hide from SR but keep clickable for outside-close
    blurOverlay.setAttribute("aria-hidden", "true");
    // Do NOT set inert here so clicks can be captured to close the cart
  },
  hideBlur() {
    /** @type {HTMLElement | null} */
    const blurOverlay = document.querySelector("#blur-overlay");
    if (!blurOverlay) return;
    blurOverlay.style.display = "none";
    blurOverlay.removeAttribute("aria-hidden");
  },
  disableScroll() {
    const scrollTop = document.documentElement.scrollTop;
    window.onscroll = function () {
      window.scrollTo(0, scrollTop);
    };
  },
  enableScroll() {
    window.onscroll = function () { };
  },
  /**
   * @param {Variant} variant - Product variant object.
   * @returns {number | string} - Discount percentage or Exclusive Offer.
   */
  calculateDiscountPercent(variant) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount =
        ((variant.compare_at_price - variant.price) * 100) /
        variant.compare_at_price;

      if (window.alwaysRoundDown) {
        return Math.floor(discount);
      } else {
        return Math.round(discount);
      }
    }
    return "Exclusive Offer";
  },
  /**
   * @param {string} handle
   * @returns {Promise<Product | null>} - Product object or null if not found.
   */
  async getProductByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) {
        console.warn(
          "error getting product by handle: ",
          res.statusText || `HTTP ${res.status}`
        );
        return null;
      }
      const data = await res.json();
      return data;
    } catch (error) {
      console.warn("error getting product by handle: ", error);
      return null;
    }
  },
  /**
   * @param {HTMLElement} element
   */
  observeElementMutation(element) {
    const observer = new MutationObserver((mutation) => {
      console.log(`${element} changed: `);
      console.trace(mutation);
    });
    observer.observe(element, { attributes: true });
  },
  /**
   *
   * @param {HTMLFormElement} form
   * @returns {string}
   */
  serializeForm(form) {
    const obj = {};
    /**
     * @type {FormData}
     */
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
  },
  /**
   *
   * @param {Function} fn
   * @param {Number} wait
   * @returns
   */
  debounce(fn, wait) {
    /**
     * @type {Number}
     */
    let timeout;

    return /** @param {any} args */ async (...args) => {
      return new Promise((resolve) => {
        clearTimeout(timeout);

        timeout = setTimeout(async () => {
          const result = await fn.apply(this, args);
          resolve(result);
        }, wait);
      });
    };
  },
  /**
   *
   * @param {string} eventName
   * @param {Object} payload
   */
  sendGtaCustomEvent(eventName, payload) {
    if (!eventName || !payload) {
      console.log("eventName or payload is missing");
      return;
    }
    if (!Shopify.analytics) {
      console.log("Shopify.analytics is not available");
      return;
    }
    console.log("publishing event", eventName, payload);
    Shopify.analytics.publish(eventName, payload);
  },
  /**
   * @param {string} string
   * @returns {string}
   */
  handleize(string) {
    console.log("handleizing string: ", string);
    if (!string) return "";
    const handleizedString = string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
    console.log("handleized string: ", handleizedString);
    return handleizedString;
  },
};

console.log("knocking library loaded");
window.knockingLibraryLoaded = true;

//# sourceMappingURL=knocking-library.js.map
